import { MouseEvent, useRef, useState } from "react";

import { LinkButton } from "@/DesignSystem";

import styles from "./SignatureViewerThreeToOneRatio.module.scss";

interface ISignatureViewerThreeToOneProps {
    signatureSource: string;
    onRemoveSignature?: (e: MouseEvent<HTMLSpanElement>) => void;
    onImageLoaded?: (isImageResized: boolean) => void;
}

function SignatureViewerThreeToOneRatio(props: Readonly<ISignatureViewerThreeToOneProps>): JSX.Element {
    const containerRef = useRef<HTMLDivElement>(null);
    const imgeRef = useRef<HTMLImageElement>(null);
    const [imgClassName, setImgClassName] = useState<string>("");
    const [containerClassName, setContainerClassName] = useState<string>("");

    const setCssClassesBasedOnImageDimensions = (): void => {
        const naturalWidth = imgeRef.current.naturalWidth;
        const naturalHeight = imgeRef.current.naturalHeight;
        const ThreeToOneRatio = 3;
        const ratioThreshold = 0.1;

        const imageRatio = naturalWidth / naturalHeight;

        props.onImageLoaded?.(Math.abs(imageRatio - ThreeToOneRatio) > ratioThreshold);

        if (imageRatio < ThreeToOneRatio) {
            setImgClassName(styles.signatureRatioUnderThreeToOne);
            setContainerClassName(styles.containerRatioUnderThreeToOne);
        }
        else {
            setImgClassName(styles.signatureRatioLargerThanThreeToOne);
            setContainerClassName(styles.containerRatioLargerThanThreeToOne);
        }
    };

    return (
        <div ref={containerRef} className={containerClassName}>
            {props.onRemoveSignature && (
                <span className={`hover-img ${styles.deletionIcon}`}>
                    <LinkButton
                        label="X"
                        onClick={e => props.onRemoveSignature(e)}
                        size="sm"
                        variant="neutral"
                        underline={false}
                    />
                </span>
            )}
            {props.signatureSource && (
                <img
                    ref={imgeRef}
                    className={imgClassName}
                    src={props.signatureSource}
                    alt="signature"
                    onLoad={setCssClassesBasedOnImageDimensions}
                />
            )}
        </div>

    );
}

export { SignatureViewerThreeToOneRatio };
